/**
 * Guest play: a slim bar reminding the guest that the civilization lives only in this browser's
 * session until the account is saved (upgrade keeps the civilization, see AccountView).
 */
import { useEffect, useState } from 'react';
import { useGameStore } from '../store/game-store.ts';
import { fetchAccount } from '../api/account.ts';

export function GuestBanner() {
  const { activeTab, setActiveTab } = useGameStore();
  const [state, setState] = useState<'hidden' | 'guest' | 'pending'>('hidden');

  useEffect(() => {
    let live = true;
    fetchAccount().then(p => { if (live) setState(!p.guest ? 'hidden' : p.upgradePending ? 'pending' : 'guest'); }).catch(() => undefined);
    return () => { live = false; };
  }, [activeTab]);

  if (state === 'hidden' || activeTab === 'account') return null;
  return (
    <div className="flex items-center gap-2 px-3 py-1 text-xs flex-shrink-0" role="status" data-testid="guest-banner"
      style={{ background: 'rgba(251,191,36,0.1)', borderBottom: '1px solid rgba(251,191,36,0.3)', color: '#fcd34d' }}>
      <span className="flex-1 min-w-0">
        {state === 'pending' ? 'Erősítsd meg az e-mail-címed, hogy a fiókod végleges legyen.' : 'Vendégként játszol — mentsd el a fiókod, hogy ne veszítsd el a civilizációd.'}
      </span>
      <button type="button" className="btn-secondary flex-shrink-0" style={{ minHeight: 44, color: '#fcd34d', borderColor: 'rgba(251,191,36,0.5)' }}
        data-testid="guest-save" onClick={() => setActiveTab('account')}>
        {state === 'pending' ? 'Részletek' : 'Fiók mentése'}
      </button>
    </div>
  );
}
